import { render } from "./doorOpen.vue?vue&type=template&id=97396d70"
import script from "./doorOpen.vue?vue&type=script&lang=js"
export * from "./doorOpen.vue?vue&type=script&lang=js"

import exportComponent from "D:\\idea\\workplace\\parking\\duty-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__